import React, { useState, useEffect } from "react";
import axiosInstance from "../api/axiosInstance";
import { useNavigate, useLocation , useParams} from "react-router-dom";

export default function MedicinePage() {
  const navigate = useNavigate();
  const location = useLocation();

const params = new URLSearchParams(location.search);

const id = params.get("id");

const isEdit = Boolean(id);

  const [form, setForm] = useState({
    name: "",
    company: "",
    salt_composition: "",
    type: "",
    selling_price: "",
    purchase_price: "",
    mrp: "",
    gst_percent: "",
    stock: "",
    expiry_date: "",
  });

  const [image, setImage] = useState(null);
  const [existingImage, setExistingImage] = useState(null);

  // ------------ FETCH SINGLE MEDICINE WHEN EDIT ------------
  useEffect(() => {
    if (isEdit) {
      axiosInstance.get(`/medicine/${id}/`)
        .then(res => {
          setForm({
            name: res.data.name || "",
            company: res.data.company || "",
            salt_composition: res.data.salt_composition || "",
            type: res.data.type || "",
            selling_price: res.data.selling_price || "",
            purchase_price: res.data.purchase_price || "",
            mrp: res.data.mrp || "",
            gst_percent: res.data.gst_percent || "",
            stock: res.data.stock || "",
            expiry_date: res.data.expiry_date || "",
          });

          if (res.data.image) {
            setExistingImage(`http://127.0.0.1:8000${res.data.image}`);
          }
        })
        .catch(() => alert("Failed to load medicine details"));
    }
  }, [isEdit, id]);

  // ------------ HANDLE INPUT CHANGE ------------
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ------------ HANDLE FORM SUBMIT ------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (isEdit) {
        // UPDATE
        await axiosInstance.put(`/update_medicine/${id}/`, form);
        alert("Medicine updated!");

        // update image separately if selected
        if (image) {
          const fd = new FormData();
          fd.append("image", image);
          await axiosInstance.post(`/update_medicine_image/${id}/`, fd);
        }
      } else {
        // CREATE
        await axiosInstance.post("/medicine/create/", form);
        alert("Medicine added!");
      }

      navigate("/shop-medicines");
    } catch (err) {
      alert("Failed! Check all fields.");
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <button onClick={() => navigate(-1)} style={{ marginBottom: 20 }}>← Back</button>

      <h2>{isEdit ? "Edit Medicine" : "Add Medicine"}</h2>

      <form onSubmit={handleSubmit} style={{ marginTop: 20 }}>
        {[
          ["name", "Medicine Name"],
          ["company", "Company"],
         ["salt_composition", "Salt Composition"],
          ["type", "Type (Tablet/Syrup)"],
          ["selling_price", "Selling Price"],
          ["purchase_price", "Purchase Price"],
          ["mrp", "MRP"],
          ["gst_percent", "GST %"],
          ["stock", "Stock"],
          ["expiry_date", "Expiry Date", "date"],
        ].map(([key, label, type = "text"]) => (
          <div key={key} style={{ marginBottom: 15 }}>
            <label>{label}</label>
            <input
              type={type}
              name={key}
              value={form[key]}
              onChange={handleChange}
              style={{ width: "100%", padding: 10, marginTop: 5 }}
              required
            />
          </div>
        ))}

        {/* IMAGE SECTION */}
        <div style={{ marginBottom: 15 }}>
          <label>Medicine Image</label>
          {existingImage && (
            <img
              src={existingImage}
              alt="existing"
              style={{ width: 150, height: 150, borderRadius: 10, display: "block", marginTop: 10 }}
            />
          )}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setImage(e.target.files[0])}
            style={{ marginTop: 10 }}
          />
        </div>

        <button
          type="submit"
          style={{
            width: "100%",
            padding: 12,
            background: "#0284C7",
            color: "white",
            border: "none",
            borderRadius: 8,
            marginTop: 20,
            fontSize: 18,
          }}
        >
          {isEdit ? "Update Medicine" : "Add Medicine"}
        </button>
      </form>
    </div>
  );
}
